import * as _ from 'lodash';
import { createSelector } from 'reselect';


export const userData = state => _.get(state.oci, 'userdata', {});
export const loading = state => _.get(state.oci, 'isLoading', false);
export const tenantList = state => _.get(state.oci, 'instances');
export const tenantInfo = state => _.get(state.oci, 'tenantInfo');
export const ociErrorTitle = state => _.get(state.oci, 'error.errorTitle','');
export const ociErrorMessage = state => _.get(state.oci, 'error.errorMessage');
export const ociErrorCode = state => _.get(state.oci, 'error.errorCode', '');
export const ociHttpErrorCode = state => _.get(state.oci, 'error.httpStatusCode',0);
export const createTenantOpErrorMessage = state => _.get(state.oci, 'tenantCreationOpError.errorMessage');
export const createTenantOpErrorCode = state => _.get(state.oci, 'tenantCreationOpError.errorCode', '');
export const createTenantOpHttpErrorCode = state => _.get(state.oci, 'tenantCreationOpError.httpStatusCode',0);
export const tenantCreationFailed = state => _.get(state.oci, 'isTenantCreationFailed', false);
export const clusterLocations = state => _.get(state.oci, 'clusterLocations', []);
export const numberOfRenewRetried = state => _.get(state.oci, 'numOfRetried', 0);
export const tokenRenewed = state => _.get(state.oci, 'tokenRenewed', '');

export const cigConfig = state => _.get(state.config, 'configure');
export const selectedLocation = state => _.get(state.config, 'selectedTenantLocation');
export const signupForm = state => _.get(state.config, 'signup.signupForms');

export const configErrorMessage = state => _.get(state.config, 'error.errorMessage');
export const configErrorCode = state => _.get(state.config, 'error.errorCode');
export const configHttpErrorCode = state => _.get(state.config, 'error.httpStatusCode');

export const authErrorMessage = state => _.get(state.auth, 'error.errorMessage');
export const authErrorCode = state => _.get(state.auth, 'error.errorCode', '');
export const authHttpError = state => _.get(state.auth, 'error.httpStatusCode');
export const userProfile = state => _.get(state.auth, 'profile') || {};

export const userErrorTitle = state => _.get(state.users, 'error.errorTitle','');
export const userErrorMessage = state => _.get(state.users, 'error.errorMessage');
export const userErrorCode = state => _.get(state.users, 'error.errorCode', '');
export const userHttpErrorCode = state => _.get(state.users, 'error.httpStatusCode', 0)



export const invitationList = createSelector (
    userData,
    (usrData) => {
        return _.isEmpty(usrData) || _.isNil(usrData.invites) ? [] : usrData.invites.results;
    }
);

export const userProfileInfo = createSelector (
    userData,
    (usrData) => {
        return _.isEmpty(usrData) ? {} : usrData.profile;
    }
);

export const userTenantDetailsList = createSelector (
    userData,
    (usrData) => {
        return _.get(usrData, 'tenants.results', []);
    }
);

export const getExtMod = createSelector (
    cigConfig,
    (config) => {
        return _.isEmpty(config) ? false :
            config.mode !== 'PROD' && config.mode !== 'PREVIEW';
    }
);

export const registrationInfo = createSelector(
    userProfileInfo,
    signupForm,
    (userProfile, signupForm) => {
        if (_.isEmpty(userProfile))
            return {};
        const existedSignupForm = _.filter(signupForm, (o) => {
            return _.isEmpty(userProfile.subject) ? false : o.userId === userProfile.subject;
        });
        return existedSignupForm.length === 0 ? {} : existedSignupForm[0];
    }
);

export const errorMessageInfo = createSelector(
    authErrorMessage,
    ociErrorMessage,
    (authErrMsg, ociErrMsg) => {
        return !_.isUndefined(authErrMsg) && !_.isEmpty(authErrMsg) ? authErrMsg : ociErrMsg;
    }
);

export const userErrorInfo = createSelector(
    userErrorTitle,
    userErrorMessage,
    userErrorCode,
    userHttpErrorCode,
    (errorTitle, errorMessage, errorCode, httpStatusCode) => {
        return {
            errorTitle,
            errorMessage,
            errorCode,
            httpStatusCode,
        }
    }
);

export const ociErrorInfo = createSelector(
    ociErrorTitle,
    ociErrorMessage,
    ociErrorCode,
    ociHttpErrorCode,
    (ociErrorTitle, errorMessage, errorCode, httpStatusCode) => {
        return {
            ociErrorTitle,
            errorMessage,
            errorCode,
            httpStatusCode,
        }
    }
);

export const authErrorInfo = createSelector(
    authErrorMessage,
    authErrorCode,
    authHttpError,
    (errorMessage, errorCode, httpStatusCode) => {
        return {
            errorMessage,
            errorCode,
            httpStatusCode,
        }
    }
);

export const configErrorInfo = createSelector(
    configErrorMessage,
    configErrorCode,
    configHttpErrorCode,
    (errorMessage, errorCode, httpStatusCode) => {
        return {
            errorMessage,
            errorCode,
            httpStatusCode,
        }
    }
);

export const createTenantErrorInfo = createSelector(
    ociErrorMessage,
    ociErrorCode,
    ociHttpErrorCode,
    createTenantOpErrorMessage,
    createTenantOpErrorCode,
    createTenantOpHttpErrorCode,
    (ciErrorMessage, ciErrorCode, ciHttpErrorCode, opErrorMessage, opErrorCode, opHttpErrorCode) => {
        return {
            errorMessage: ciErrorMessage || opErrorMessage,
            errorCode: ciErrorCode || opErrorCode,
            httpStatusCode: ciHttpErrorCode || opHttpErrorCode,
        }
    }
);
